'use memo';

import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { ApiResponseBody } from '@/lib/api/api-type-helper';
import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import { getPath } from '@/lib/api/path';
import { FIVE_MINUTES } from '@/lib/query';
const BANKS_PATH = getPath('/v2/banks');
type BankSearchResponse = ApiResponseBody<'/v2/banks', 'get'>;
export type CodeNameEntry = BankSearchResponse['items'][number];
export const useBanks = (searchTerm: string) => {
  const {
    data,
    isLoading,
    isFetching,
    error
  } = useQuery({
    queryKey: [BANKS_PATH, {
      searchTerm
    }] as const,
    queryFn: async ({
      queryKey: [path, {
        searchTerm
      }]
    }) => getDataOrThrowApiError(await apiClient.GET(path, {
      params: {
        query: searchTerm ? {
          query: searchTerm
        } : {}
      }
    })),
    staleTime: FIVE_MINUTES,
    placeholderData: keepPreviousData
  });
  return {
    banks: data?.items ?? [],
    isLoading,
    isFetching,
    error
  };
};